/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import RelaisSelfcareSouscriptionPricingMutation from '../graphql/mutations/RelaisSelfcareSouscriptionPricingMutation.js';

export const useRelaisSelfcareSouscriptionPricingMutation = () => {
  return useCommitMutation(RelaisSelfcareSouscriptionPricingMutation, { dataProp: 'relaisSelfcareSouscriptionPricing_M_souscription_pricing' });
};

export default useRelaisSelfcareSouscriptionPricingMutation;
